/**
 * Utility functions for working with LTI data
 */

/**
 * Generates a unique LTI user ID by combining tool_consumer_instance_guid and user_id
 * Both values must be present to generate a valid ID
 * @param {Object} ltiData - The LTI data object containing user and consumer information
 * @returns {string|undefined} A globally unique LTI user identifier or undefined if insufficient data
 */
export function generateLtiUserId(ltiData) {
  if (!ltiData) return undefined;
  
  // Get the tool consumer instance GUID (identifies the LMS instance)
  const consumerGuid = ltiData.tool_consumer_instance_guid || '';
  
  // Get the user ID from the LTI data
  const userId = ltiData.user_id || '';
  
  // Only create a composite ID if both required components are present
  if (consumerGuid && userId) {
    return `${consumerGuid}-${userId}`;
  }
  
  // If either component is missing, return undefined to indicate generation failure
  return undefined;
}
